import { isMobile } from '../../../Assets/configuration/index.js';

/* SHARE BUTTON */
class ShareButton extends HTMLElement {
  constructor() {
    super();

    const shareData = {
      title: 'J’ai pensé que cet article pourrait t’intéresser',
      url: Object.assign(new URL(document.location), { hash: '' }).href,
      text: `Bonjour,

Je viens de découvrir sur Fnac.com cet article qui pourrait t’intéresser :

${Object.assign(new URL(document.location), { hash: '' }).href}

A bientôt.`
    };

    if (globalThis.navigator.canShare !== undefined && globalThis.navigator.canShare(shareData) && isMobile) {
      delete this.querySelector('[data-a11y-dialog-show]').dataset.a11yDialogShow;

      this.addEventListener('click', (event) => {
        event.preventDefault();
        globalThis.navigator.share(shareData);
      });
    }

    this.removeAttribute('aria-hidden');
  }
}

customElements.get('f-share-button') || customElements.define('f-share-button', ShareButton);
